import { useLocation } from 'react-router-dom';
import BusinessesHome from './businesses/businesses-home';
import Transactions from './transactions/transactions-home';
import TransactionsHome from './transactions/transactions-home';
import CategoriesHome from './categories/categories-home';
import GasHome from './gas/gas-home';

const FinanceHome = () => {

    const { pathname } = useLocation();

    return (
        <div className="flex flex-col flex-1 leading-7 h-screen relative z-50 bg-white w-screen">
            <div className="overflow-auto px-6 pb-10">
                <div className="xl:max-w-[1100px] max-w-full mx-auto py-10">
                    {
                        pathname === '/finance' && <Transactions/>
                    }

                    {
                        pathname === '/finance/categories' && <CategoriesHome/>
                    }

                    {
                        pathname === '/finance/businesses' && <BusinessesHome/>
                    }

                    {
                        pathname === '/finance/transactions' && <TransactionsHome/>
                    }

                    {
                        pathname === '/finance/gas' && <GasHome/>
                    }

                </div>

            </div>
        </div>
    )
};

export default FinanceHome;